import { Instagram, Linkedin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        <li className="h-3 w-24 bg-muted animate-pulse rounded-md" />
        <li className="h-3 w-20 bg-muted animate-pulse rounded-md" />
        <li className="h-3 w-28 bg-muted animate-pulse rounded-md" />
        <li className="h-3 w-16 bg-muted animate-pulse rounded-md" />
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li data-index={i} key={item.id}>
          <Link to={item.href || "#"} className="font-default text-[11px] uppercase tracking-widest text-foreground/70 hover:text-accent transition-colors duration-200">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
const workLinks = [{
  label: "Home",
  href: "/HomePage"
}, {
  label: "Services",
  href: "/ServicesPage"
}, {
  label: "Pricing",
  href: "/PricingPage"
}, {
  label: "How It Works",
  href: "/HowItWorks"
}];
const socialLinks = [{
  label: "Instagram",
  icon: Instagram,
  href: "https://instagram.com"
}, {
  label: "LinkedIn",
  icon: Linkedin,
  href: "https://linkedin.com"
}];
export default function Footer() {
  return <section data-section-id="571" id="footer" className="dark bg-background text-foreground relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none opacity-[0.04]" style={{
      backgroundImage: "linear-gradient(to right, var(--foreground) 1px, transparent 1px), linear-gradient(to bottom, var(--foreground) 1px, transparent 1px)",
      backgroundSize: "80px 80px"
    }} aria-hidden="true" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-10 lg:px-16 py-20 md:py-[100px]">
        <div className="mb-16 md:mb-24">
          <div className="flex items-center gap-4 mb-8">
            <span className="font-default text-[10px] uppercase tracking-widest text-foreground/50">
              01 — Advocate
            </span>
            <div className="h-px flex-1 bg-border/60" />
          </div>
          <h2 className="font-default text-foreground leading-[0.95] tracking-tight" style={{
          fontSize: "clamp(3rem, 7vw, 6rem)"
        }}>
            <span className="italic font-light">Your partner in</span>
            <br />
            <span className="italic font-light">securing </span>
            <span className="font-normal">better deals.</span>
          </h2>
        </div>

        <div className="h-px w-full bg-border/60 mb-16" />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          <div className="flex flex-col">
            <Link to="/" className="inline-block mb-6">
              <WvcLogo className="h-8 w-auto" />
            </Link>
            <p className="font-default text-[11px] uppercase tracking-widest text-foreground/60 leading-relaxed max-w-[200px]">
              Price Advocate Services
              <br />
              Consumer Negotiation Experts
            </p>
          </div>

          <div>
            <h3 className="font-default text-[10px] uppercase tracking-widest text-foreground/40 mb-6">
              Navigation
            </h3>
            <MenuProvider menu_id="5">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          <div>
            <h3 className="font-default text-[10px] uppercase tracking-widest text-foreground/40 mb-6">
              Quick Links
            </h3>
            <ul className="space-y-3">
              {workLinks.map((link, i) => <li data-index={i} key={link.label}>
                  <Link to={link.href} className="font-default text-[11px] uppercase tracking-widest text-foreground/70 hover:text-accent transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          <div>
            <h3 className="font-default text-[10px] uppercase tracking-widest text-foreground/40 mb-6">
              Contact
            </h3>
            <address className="not-italic space-y-4">
              <p className="font-default italic text-base text-foreground/90 leading-relaxed">
                123 Negotiation Way
                <br />
                Advocate City, AC 90210
              </p>
              <p className="font-default text-[11px] uppercase tracking-widest text-foreground/70">
                <Link to="tel:5551234567" className="hover:text-accent transition-colors duration-200">
                  (555) 123-4567
                </Link>
              </p>
              <p className="font-default text-[11px] uppercase tracking-widest">
                <Link to="mailto:hello@priceadvocate.com" className="text-foreground/70 hover:text-accent transition-colors duration-200 underline underline-offset-4 decoration-foreground/30">
                  hello@priceadvocate.com
                </Link>
              </p>
            </address>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-border/60 flex flex-col md:flex-row items-center justify-between gap-6">
          <p className="font-default text-[10px] uppercase tracking-widest text-foreground/50">
            © {new Date().getFullYear()} Price Advocate Services — All Rights Reserved
          </p>
          <div className="flex items-center gap-6">
            {socialLinks.map((social, i) => {
            const Icon = social.icon;
            return <Link data-index={i} key={social.label} to={social.href} newTab aria-label={social.label} className="text-foreground/60 hover:text-accent transition-colors duration-200">
                  <Icon className="h-4 w-4" strokeWidth={1} />
                </Link>;
          })}
          </div>
        </div>
      </div>
    </section>;
}